import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
import { MOBILE_STICKY_BUTTON_SPEC } from '../utils/consts';
import { availableCyclesFromPricingDetails, clampToAvailableCycle, productFamilyFromId, recommendedCycleToPurchaseCycle } from './cycleRecommendation.utils';
import { resolveCurrentDefaultCycle } from './resolveCurrentDefaultCycle';
import { useEclipseCycleRecommendation } from './useEclipseCycleRecommendation';
export const useCycleDefaultDecision = () => {
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    data: discountData,
    isLoading: isDiscountLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const {
    data: product,
    isLoading: isProductLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId: selectedProductId ?? ''
  }, Boolean(selectedProductId));
  const {
    cycleByFamily,
    correlationId,
    isEligible,
    isError,
    isTimeout,
    isLoading: isRecommendationLoading
  } = useEclipseCycleRecommendation();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isMobile = module.moduleName === 'eclipse-package-picker-mobile-module';
  const isStickyButtonYearly = isMobile && experiments.isEnabled(MOBILE_STICKY_BUTTON_SPEC);
  const isProductPending = Boolean(selectedProductId) && isProductLoading;
  const isLoading = isDiscountLoading || isRecommendationLoading || isEligible && isProductPending;
  const productFamily = productFamilyFromId(product == null ? void 0 : product.productFamilyId);
  const recommendedCycle = isEligible ? productFamily && cycleByFamily[productFamily] : undefined;
  const recommendedPurchaseCycle = recommendedCycleToPurchaseCycle(recommendedCycle);
  const availableCycles = availableCyclesFromPricingDetails(product == null ? void 0 : product.pricingDetails);
  const currentDefaultCycle = resolveCurrentDefaultCycle({
    hasSale: discountData == null ? void 0 : discountData.hasSale,
    alwaysDefaultsToYearly: isStickyButtonYearly && !isEligible
  });
  const presetCycle = recommendedPurchaseCycle ? clampToAvailableCycle(recommendedPurchaseCycle, availableCycles) : currentDefaultCycle;
  const resolveFallbackReason = () => {
    if (!isEligible || recommendedPurchaseCycle) {
      return undefined;
    }
    if (isTimeout) {
      return 'resolver_timeout';
    }
    if (isError) {
      return 'resolver_error';
    }
    if (!correlationId) {
      return 'no_prefetch';
    }
    return productFamily ? 'suppressed_product' : 'unknown_product_family';
  };
  return {
    presetCycle,
    recommendedCycle: recommendedCycle || undefined,
    productFamily,
    availableCycles,
    applied: isEligible && Boolean(recommendedPurchaseCycle),
    fallbackReason: resolveFallbackReason(),
    correlationId,
    isEligible,
    isProductLoading: isProductPending,
    isLoading
  };
};
export const toServedCycleLabel = cycle => {
  if (!cycle) {
    return undefined;
  }
  const cycleId = CycleUtils.convertCycleToCycleId(cycle);
  return cycleId === '1-YEAR' || cycleId === '2-YEAR' || cycleId === '3-YEAR' ? cycleId : undefined;
};
//# sourceMappingURL=useCycleDefaultDecision.js.map